export default {
	//hosted
	api_base_url: "https://backend-tizecash-506b8e836d0c.herokuapp.com/tizecash-api/v1",
	isMaintenance: true,

	// local backend
	//api_base_url: "http://localhost:8080/tizecash-api/v1"

	// external backend (if testing from another device)
	//api_base_url: "http://192.168.2.17:8080/tizecash-api/v1"
};
